<template>
  <div v-if="selectedPolicy && isOpen">
    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>General Surcharge ({{ selectedPolicy.policyTitle }})</h4>
                <h6>
                  Last Updated: {{ model.modifiedDate ? model.modifiedDate.stringFullDate : '-' }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <ul class="nav nav-tabs nav-justified tabs-mini-form">
                    <li :class="[activeTab === 'nighttime' ? 'active' : '']">
                      <a
                        href="#night-surcharge"
                        data-toggle="tab"
                        @click="activeTab = 'nighttime'"
                        >Night</a
                      >
                    </li>
                    <li :class="[activeTab === 'weekend' ? 'active' : '']">
                      <a
                        href="#weekend-surcharge"
                        data-toggle="tab"
                        @click="activeTab = 'weekend'"
                        >Weekend</a
                      >
                    </li>
                    <li :class="[activeTab === 'garage' ? 'active' : '']">
                      <a
                        href="#garage-surcharge"
                        data-toggle="tab"
                        @click="activeTab = 'garage'"
                        >Garage</a
                      >
                    </li>
                    <li :class="[activeTab === 'others' ? 'active' : '']">
                      <a href="#others" data-toggle="tab" @click="activeTab = 'others'"
                        >Others</a
                      >
                    </li>
                  </ul>
                  <form role="form" action="#" id="vueform">
                    <div class="tab-content">
                      <div
                        id="night-surcharge"
                        class="tab-pane fade"
                        :class="[activeTab === 'nighttime' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Start Time</label>
                              <VueCtkDateTimePicker
                                id="nightTimeSurchargeStart"
                                v-model="model.nightTimeSurchargeStart"
                                color="#025BC5"
                                format="HH:mm"
                                formatted="HH:mm"
                                label="Select time"
                                only-time
                                no-label
                                no-button
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>End Time</label>
                              <VueCtkDateTimePicker
                                id="nightTimeSurchargeEnd"
                                v-model="model.nightTimeSurchargeEnd"
                                color="#025BC5"
                                format="HH:mm"
                                formatted="HH:mm"
                                label="Select time"
                                only-time
                                no-label
                                no-button
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>
                                Flat Rate
                                <span class="--grey50" v-if="moneyFormat"
                                  >({{ moneyFormat.currencyCode }})</span
                                >
                              </label>
                              <span class="label-desc"> For airport transfer </span>
                              <currency-input
                                name="nightTimeSurchargeFlatRate"
                                class="form-control"
                                autocomplete="off"
                                placeholder="Enter rate"
                                v-model="model.nightTimeSurchargeFlatRate"
                                :allow-negative="false"
                                :currency="null"
                                :locale="moneyFormat.cultureCode"
                                :precision="moneyFormat.numberOfDecimal"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>
                                Hourly Rate
                                <span class="--grey50" v-if="moneyFormat"
                                  >({{ moneyFormat.currencyCode }})
                                </span>
                              </label>
                              <span class="label-desc"> For hourly hire </span>
                              <currency-input
                                name="nightTimeSurchargeHourlyRate"
                                class="form-control"
                                autocomplete="off"
                                placeholder="Enter rate"
                                v-model="model.nightTimeSurchargeHourlyRate"
                                :allow-negative="false"
                                :currency="null"
                                :locale="moneyFormat.cultureCode"
                                :precision="moneyFormat.numberOfDecimal"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Percentage Charge</label>
                              <span class="label-desc">
                                If flat rate/hourly rate is not exist then calculation
                                will use percentage
                              </span>
                              <input
                                type="number"
                                name="nightTimeSurchargePercentage"
                                class="form-control"
                                v-model="model.nightTimeSurchargePercentage"
                                min="0"
                                step="any"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="weekend-surcharge"
                        class="tab-pane fade"
                        :class="[activeTab === 'weekend' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>
                                Flat Rate
                                <span class="--grey50" v-if="moneyFormat"
                                  >({{ moneyFormat.currencyCode }})</span
                                >
                              </label>
                              <currency-input
                                name="weekendSurchargeFlatRate"
                                class="form-control"
                                autocomplete="off"
                                placeholder="Enter rate"
                                v-model="model.weekendSurchargeFlatRate"
                                :allow-negative="false"
                                :currency="null"
                                :locale="moneyFormat.cultureCode"
                                :precision="moneyFormat.numberOfDecimal"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>
                                Hourly Rate
                                <span class="--grey50" v-if="moneyFormat"
                                  >({{ moneyFormat.currencyCode }})</span
                                >
                              </label>
                              <currency-input
                                name="weekendSurchargeHourlyRate"
                                class="form-control"
                                autocomplete="off"
                                placeholder="Enter rate"
                                v-model="model.weekendSurchargeHourlyRate"
                                :allow-negative="false"
                                :currency="null"
                                :locale="moneyFormat.cultureCode"
                                :precision="moneyFormat.numberOfDecimal"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Percentage Charge</label>
                              <input
                                type="number"
                                name="weekendSurchargePercentage"
                                class="form-control"
                                v-model="model.weekendSurchargePercentage"
                                min="0"
                                step="any"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Days</label>
                              <multiselect
                                v-model="model.weekendSurchargeDays"
                                :options="weekends"
                                :multiple="true"
                                :close-on-select="false"
                                placeholder="Select day"
                                label=""
                                track-by=""
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="garage-surcharge"
                        class="tab-pane fade"
                        :class="[activeTab === 'garage' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>
                                Fixed Rate
                                <span class="--grey50" v-if="moneyFormat">
                                  ({{ moneyFormat.currencyCode }})
                                </span>
                              </label>
                              <currency-input
                                name="garageTimeFixedRate"
                                class="form-control"
                                autocomplete="off"
                                placeholder="Enter rate"
                                v-model="model.garageTimeFixedRate"
                                :allow-negative="false"
                                :currency="null"
                                :locale="moneyFormat.cultureCode"
                                :precision="moneyFormat.numberOfDecimal"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Duration Band (minute)</label>
                              <input
                                type="number"
                                name="garageTimeBandMinutes"
                                class="form-control"
                                v-model="model.garageTimeBandMinutes"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Minimum Band</label>
                              <input
                                type="number"
                                name="garageTimeBandMinimum"
                                class="form-control"
                                v-model="model.garageTimeBandMinimum"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="others"
                        class="tab-pane fade"
                        :class="[activeTab === 'others' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Minimum Hire (hour)</label>
                              <input
                                type="number"
                                name="minimumHourlyHire"
                                class="form-control"
                                v-model="model.minimumHourlyHire"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Rounding Time (minute)</label>
                              <input
                                type="number"
                                name="minuteRoundingTime"
                                class="form-control"
                                v-model="model.minuteRoundingTime"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Remark</label>
                              <textarea
                                class="form-control"
                                rows="3"
                                name="remark"
                                v-model="model.remark"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer" v-if="isAllowToCreate || isAllowToUpdate">
                      <button
                        type="button"
                        class="btn btn-default"
                        @click.prevent="closeModal()"
                      >
                        Cancel
                      </button>
                      <button
                        v-if="!isUpdate && isAllowToCreate"
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="createItem()"
                      >
                        Create
                      </button>
                      <button
                        v-if="isUpdate && isAllowToUpdate"
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="updateItem()"
                      >
                        Update
                      </button>
                      <button
                        v-if="isUpdate && isAllowToDelete"
                        type="submit"
                        class="btn btn-default sts-danger"
                        @click.prevent="confirmDelete(selectedPolicy.policyId)"
                      >
                        Delete
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import deleteModal from "@/components/shared/DeleteModal";
import buyingTariffGeneralSurchargeService from "@/services/master/buyingTariff/buyingTariffOverriddenGeneralSurchargeService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isOpen: false,
      weekends: [],
      model: {
        nightTimeSurchargeStart: "19:00",
        nightTimeSurchargeEnd: "06:59",
      },
      activeTab: "nighttime",
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedPolicy: null,
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      isLoading: false,
      msg: "Please wait",
    };
  },
  created() {
    this.$eventBus.$on(
      "initializeBuyingTariffOverriddenGeneralSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenGeneralSurcharge");
  },
  methods: {
    async initialize(policy) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedPolicy = policy;
        this.moneyFormat = policy.moneyFormat;
        this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
          style: "currency",
          currency: policy.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: policy.moneyFormat.numberOfDecimal,
        });

        this.activeTab = "nighttime";
        this.reset();

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["BuyingTariffOverriddenGeneralSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.weekends = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];
          await this.getAll();
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    resetModel() {
      this.activeTab = "nighttime";
      this.model = {};
    },
    openModal(object) {
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.resetModel();
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    reset() {
      this.isUpdate = false;
      this.model = {};
    },
    async getAll() {
      try {
        this.isLoading = true;
        this.model = await buyingTariffGeneralSurchargeService.getAll(
          this.selectedPolicy.policyId
        );
        if (this.model === null) {
          this.isUpdate = false;
          this.model = { isActive: true };
        } else {
          this.isUpdate = true;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    resolveProperty() {
      if (this.model.garageTimeFixedRate) {
        this.model.garageTimeFixedRate = parseFloat(this.model.garageTimeFixedRate);
      }

      if (this.model.garageTimeBandMinimum) {
        this.model.garageTimeBandMinimum = parseFloat(this.model.garageTimeBandMinimum);
      }

      if (this.model.garageTimeBandMinutes) {
        this.model.garageTimeBandMinutes = parseFloat(this.model.garageTimeBandMinutes);
      }

      if (this.model.minimumHourlyHire) {
        this.model.minimumHourlyHire = parseInt(this.model.minimumHourlyHire);
      }

      if (this.model.minuteRoundingTime) {
        this.model.minuteRoundingTime = parseInt(this.model.minuteRoundingTime);
      }

      if (
        this.model.nightTimeSurchargeStart &&
        this.model.nightTimeSurchargeStart !== "" &&
        this.model.nightTimeSurchargeEnd &&
        this.model.nightTimeSurchargeEnd !== ""
      ) {
        if (
          this.model.nightTimeSurchargePercentage &&
          this.model.nightTimeSurchargePercentage !== ""
        ) {
          this.model.nightTimeSurchargePercentage = parseFloat(
            this.model.nightTimeSurchargePercentage
          );
        } else {
          this.model.nightTimeSurchargePercentage = null;
        }

        if (
          this.model.nightTimeSurchargeFlatRate &&
          this.model.nightTimeSurchargeFlatRate !== ""
        ) {
          this.model.nightTimeSurchargeFlatRate = parseFloat(
            this.model.nightTimeSurchargeFlatRate
          );
        } else {
          this.model.nightTimeSurchargeFlatRate = null;
        }

        if (
          this.model.nightTimeSurchargeHourlyRate &&
          this.model.nightTimeSurchargeHourlyRate !== ""
        ) {
          this.model.nightTimeSurchargeHourlyRate = parseFloat(
            this.model.nightTimeSurchargeHourlyRate
          );
        } else {
          this.model.nightTimeSurchargeHourlyRate = null;
        }
      } else {
        delete this.model.nightTimeSurchargeStart;
        delete this.model.nightTimeSurchargeEnd;
        delete this.model.nightTimeSurchargePercentage;
        delete this.model.nightTimeSurchargeFlatRate;
        delete this.model.nightTimeSurchargeHourlyRate;
      }

      if (this.model.weekendSurchargeDays && this.model.weekendSurchargeDays.length > 0) {
        if (
          this.model.weekendSurchargeFlatRate &&
          this.model.weekendSurchargeFlatRate !== ""
        ) {
          this.model.weekendSurchargeFlatRate = parseFloat(
            this.model.weekendSurchargeFlatRate
          );
        } else {
          this.model.weekendSurchargeFlatRate = null;
        }

        if (
          this.model.weekendSurchargeHourlyRate &&
          this.model.weekendSurchargeHourlyRate !== ""
        ) {
          this.model.weekendSurchargeHourlyRate = parseFloat(
            this.model.weekendSurchargeHourlyRate
          );
        } else {
          this.model.weekendSurchargeHourlyRate = null;
        }

        if (
          this.model.weekendSurchargePercentage &&
          this.model.weekendSurchargePercentage !== ""
        ) {
          this.model.weekendSurchargePercentage = parseFloat(
            this.model.weekendSurchargePercentage
          );
        } else {
          this.model.weekendSurchargePercentage = null;
        }
      } else {
        delete this.model.weekendSurchargeDays;
        delete this.model.weekendSurchargeFlatRate;
        delete this.model.weekendSurchargeHourlyRate;
        delete this.model.weekendSurchargePercentage;
      }
    },
    async createItem() {
      try {
        this.isLoading = true;
        this.model.policyId = this.selectedPolicy.policyId;
        this.resolveProperty();
        await buyingTariffGeneralSurchargeService.create(this.model);
        this.$notification.success("Successfully added.", { title: "Success" });
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async updateItem(item) {
      try {
        this.isLoading = true;
        this.model.policyId = this.selectedPolicy.policyId;
        this.resolveProperty();
        await buyingTariffGeneralSurchargeService.update(this.model);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await buyingTariffGeneralSurchargeService.delete(this.itemToBeDeleted);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.isItemHasBeenModified = true;
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.header-picker {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/master/buyingTariff/OverriddenGeneralSurcharge.vue